import { observer } from 'mobx-react-lite';
import { Loader2, Percent, AlertCircle } from 'lucide-react';
import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { DiscountModal as DiscountModalCtrl } from '@/controllers/clients/clientCard/useDiscountModal';

type Props = { ctrl: DiscountModalCtrl };

export const DiscountModal = observer(function DiscountModal({ ctrl }: Props) {
  const noAbPlata = ctrl.abPlata === '0';

  return (
    <Modal
      isOpen={ctrl.isOpen}
      onClose={ctrl.close}
      title='Изменить скидку'
      subtitle={ctrl.cameraName}
      size='md'
      footer={
        <>
          <Button variant='outline' onClick={ctrl.close} className='flex-1'>
            Отмена
          </Button>
          <Button
            onClick={ctrl.submit}
            disabled={ctrl.isLoading || noAbPlata}
            className='flex-1 gap-2'
          >
            {ctrl.isLoading ? (
              <Loader2 className='w-4 h-4 animate-spin' />
            ) : (
              <Percent className='w-4 h-4' />
            )}
            Сохранить
          </Button>
        </>
      }
    >
      <div className='space-y-4'>
        {noAbPlata && (
          <div className='flex items-center gap-2 p-3 bg-destructive/10 border border-destructive/30 rounded-xl text-destructive text-sm'>
            <AlertCircle className='w-4 h-4 shrink-0' />
            Скидка неприменима: абонентская плата тарифа равна 0
          </div>
        )}
        <div>
          <Label className='text-xs font-medium text-muted-foreground uppercase tracking-wider block mb-1.5'>
            Скидка (%)
          </Label>
          <Input
            type='number'
            min='0'
            max='100'
            placeholder='0'
            value={ctrl.discount}
            onChange={(e) => ctrl.setDiscount(e.target.value)}
            className='bg-muted/30 border-border/50 focus-visible:border-primary/50 focus-visible:ring-0'
          />
        </div>
        <div>
          <Label className='text-xs font-medium text-muted-foreground uppercase tracking-wider block mb-1.5'>
            Дата
          </Label>
          <Input
            type='date'
            value={ctrl.date}
            onChange={(e) => ctrl.setDate(e.target.value)}
            className='bg-muted/30 border-border/50 focus-visible:border-primary/50 focus-visible:ring-0'
          />
        </div>
        <div>
          <Label className='text-xs font-medium text-muted-foreground uppercase tracking-wider block mb-1.5'>
            Комментарий
          </Label>
          <Input
            type='text'
            placeholder='Необязательно'
            value={ctrl.comments}
            onChange={(e) => ctrl.setComments(e.target.value)}
            className='bg-muted/30 border-border/50 focus-visible:border-primary/50 focus-visible:ring-0'
          />
        </div>
        {ctrl.error && (
          <div className='flex items-center gap-2 p-3 bg-destructive/10 border border-destructive/30 rounded-xl text-destructive text-sm'>
            <AlertCircle className='w-4 h-4 shrink-0' />
            {ctrl.error}
          </div>
        )}
      </div>
    </Modal>
  );
});
